
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.555 8.646L15.427.76a.564.564 0 01.79 0v.001l1.628 1.627v.001a.564.564 0 01.163.394.57.57 0 01-.162.393L7.525 13.497l-.002.002a.564.564 0 01-.789 0L.761 7.525a.564.564 0 010-.79l1.63-1.63a.564.564 0 01.788 0l3.526 3.54.425.426.425-.425z","stroke":"currentColor","stroke-width":"1.2"}})])
          )
        }
      }
    